import { LegalList, Logo } from '../components';
import type { FooterProps } from '../types';

export function FooterSlim(props: FooterProps) {
  return (
    <>
      <LegalList {...props} />
      <Logo />
    </>
  );
}
